// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.6_webpack@5.105.0_esbuild@0.28.0_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.6_webpack@5.105.0_esbuild@0.28.0_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global CSS Variables & Token Defaults */
:root {
  --font-title: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-takeaway: 'Space Grotesk', 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  /* Premium HSL-tailored Color Palette */
  --bg-primary: #06060c;
  --bg-secondary: #0d0d18;
  --color-text-primary: #f8f9fa;
  --color-text-secondary: #a0aec0;
  
  --accent-cyan: #00f2fe;
  --accent-purple: #9d4edd;
  --accent-yellow: #ffd166;
  --accent-pink: #ff007f;
  
  /* Glowing drop-shadows & glassmorphism variables */
  --glow-cyan: 0 0 15px rgba(0, 242, 254, 0.45);
  --glow-purple: 0 0 15px rgba(157, 78, 221, 0.45);
  --glow-yellow: 0 0 15px rgba(255, 209, 102, 0.45);
  
  --glass-bg: rgba(13, 13, 25, 0.65);
  --glass-border: rgba(255, 255, 255, 0.08);
  --glass-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  --glass-filter: blur(16px);
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
}

body {
  background-color: var(--bg-primary);
  color: var(--color-text-primary);
  font-family: var(--font-body);
  overflow: hidden;
}

/* Base Canvas for Remotion Composition */
.reel-canvas {
  width: 1080px;
  height: 1920px;
  background-color: var(--bg-primary);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* MOBILE SAFE ZONES ENFORCED: Top 240px (indicator clear), Bottom 380px (caption clear), Side 70px */
  padding: 240px 70px 380px 70px;
}

/* Glassmorphic Container styling */
.glass-panel {
  background: var(--glass-bg);
  backdrop-filter: var(--glass-filter);
  -webkit-backdrop-filter: var(--glass-filter);
  border: 1px solid var(--glass-border);
  border-radius: 24px;
  box-shadow: var(--glass-shadow);
  padding: 30px;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Glowing Neon Borders */
.glow-border-cyan {
  border: 1px solid rgba(0, 242, 254, 0.35);
  box-shadow: var(--glass-shadow), 0 0 15px rgba(0, 242, 254, 0.1);
}

.glow-border-purple {
  border: 1px solid rgba(157, 78, 221, 0.35);
  box-shadow: var(--glass-shadow), 0 0 15px rgba(157, 78, 221, 0.1);
}

/* Dynamic Text Gradients */
.gradient-text-cyan-purple {
  background: linear-gradient(135deg, var(--accent-cyan) 0%, var(--accent-purple) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.gradient-text-yellow {
  background: linear-gradient(135deg, #fff 30%, var(--accent-yellow) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Progress Bar at the top of the Reel */
.progress-bar-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 12px;
  background: rgba(255, 255, 255, 0.05);
  z-index: 100;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent-cyan), var(--accent-purple), var(--accent-pink));
  box-shadow: 0 0 10px rgba(0, 242, 254, 0.7);
}

/* Badges */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: 50px;
  font-family: var(--font-title);
  font-weight: 700;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.badge-cyan {
  background: rgba(0, 242, 254, 0.1);
  color: var(--accent-cyan);
  border: 1px solid rgba(0, 242, 254, 0.3);
  box-shadow: 0 0 15px rgba(0, 242, 254, 0.15);
}

.badge-purple {
  background: rgba(157, 78, 221, 0.1);
  color: var(--accent-purple);
  border: 1px solid rgba(157, 78, 221, 0.3);
  box-shadow: 0 0 15px rgba(157, 78, 221, 0.15);
}

/* Subtitle Highlights */
.subtitle-word {
  display: inline-block;
  font-family: var(--font-title);
  font-weight: 900;
  font-size: 42px; /* Scaled down for perfect visual hierarchy under 54px takeaways */
  margin: 4px 8px;
  transition: all 0.1s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  color: rgba(255, 255, 255, 0.3);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.subtitle-word.active {
  color: #fff;
  transform: scale(1.15);
  text-shadow: 0 0 15px rgba(0, 242, 254, 0.5), 0 0 30px rgba(157, 78, 221, 0.3);
  background: linear-gradient(135deg, #ffffff 20%, var(--accent-cyan) 60%, var(--accent-yellow) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,yFAAyF;EACzF,uFAAuF;EACvF,6GAA6G;;EAE7G,uCAAuC;EACvC,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;;EAE/B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;;EAEtB,mDAAmD;EACnD,6CAA6C;EAC7C,gDAAgD;EAChD,iDAAiD;;EAEjD,kCAAkC;EAClC,yCAAyC;EACzC,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qGAAqG;EACrG,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,4CAA4C;EAC5C,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,kDAAkD;AACpD;;AAEA,yBAAyB;AACzB;EACE,yCAAyC;EACzC,gEAAgE;AAClE;;AAEA;EACE,0CAA0C;EAC1C,iEAAiE;AACnE;;AAEA,2BAA2B;AAC3B;EACE,qFAAqF;EACrF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,wEAAwE;EACxE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gGAAgG;EAChG,2CAA2C;AAC7C;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe,EAAE,kEAAkE;EACnF,eAAe;EACf,4DAA4D;EAC5D,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,8EAA8E;EAC9E,mGAAmG;EACnG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB","sourcesContent":["/* Global CSS Variables & Token Defaults */\n:root {\n  --font-title: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-takeaway: 'Space Grotesk', 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\n  /* Premium HSL-tailored Color Palette */\n  --bg-primary: #06060c;\n  --bg-secondary: #0d0d18;\n  --color-text-primary: #f8f9fa;\n  --color-text-secondary: #a0aec0;\n  \n  --accent-cyan: #00f2fe;\n  --accent-purple: #9d4edd;\n  --accent-yellow: #ffd166;\n  --accent-pink: #ff007f;\n  \n  /* Glowing drop-shadows & glassmorphism variables */\n  --glow-cyan: 0 0 15px rgba(0, 242, 254, 0.45);\n  --glow-purple: 0 0 15px rgba(157, 78, 221, 0.45);\n  --glow-yellow: 0 0 15px rgba(255, 209, 102, 0.45);\n  \n  --glass-bg: rgba(13, 13, 25, 0.65);\n  --glass-border: rgba(255, 255, 255, 0.08);\n  --glass-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);\n  --glass-filter: blur(16px);\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n}\n\nbody {\n  background-color: var(--bg-primary);\n  color: var(--color-text-primary);\n  font-family: var(--font-body);\n  overflow: hidden;\n}\n\n/* Base Canvas for Remotion Composition */\n.reel-canvas {\n  width: 1080px;\n  height: 1920px;\n  background-color: var(--bg-primary);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  /* MOBILE SAFE ZONES ENFORCED: Top 240px (indicator clear), Bottom 380px (caption clear), Side 70px */\n  padding: 240px 70px 380px 70px;\n}\n\n/* Glassmorphic Container styling */\n.glass-panel {\n  background: var(--glass-bg);\n  backdrop-filter: var(--glass-filter);\n  -webkit-backdrop-filter: var(--glass-filter);\n  border: 1px solid var(--glass-border);\n  border-radius: 24px;\n  box-shadow: var(--glass-shadow);\n  padding: 30px;\n  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Glowing Neon Borders */\n.glow-border-cyan {\n  border: 1px solid rgba(0, 242, 254, 0.35);\n  box-shadow: var(--glass-shadow), 0 0 15px rgba(0, 242, 254, 0.1);\n}\n\n.glow-border-purple {\n  border: 1px solid rgba(157, 78, 221, 0.35);\n  box-shadow: var(--glass-shadow), 0 0 15px rgba(157, 78, 221, 0.1);\n}\n\n/* Dynamic Text Gradients */\n.gradient-text-cyan-purple {\n  background: linear-gradient(135deg, var(--accent-cyan) 0%, var(--accent-purple) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.gradient-text-yellow {\n  background: linear-gradient(135deg, #fff 30%, var(--accent-yellow) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Progress Bar at the top of the Reel */\n.progress-bar-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  z-index: 100;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent-cyan), var(--accent-purple), var(--accent-pink));\n  box-shadow: 0 0 10px rgba(0, 242, 254, 0.7);\n}\n\n/* Badges */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 16px;\n  border-radius: 50px;\n  font-family: var(--font-title);\n  font-weight: 700;\n  font-size: 18px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  margin-bottom: 20px;\n}\n\n.badge-cyan {\n  background: rgba(0, 242, 254, 0.1);\n  color: var(--accent-cyan);\n  border: 1px solid rgba(0, 242, 254, 0.3);\n  box-shadow: 0 0 15px rgba(0, 242, 254, 0.15);\n}\n\n.badge-purple {\n  background: rgba(157, 78, 221, 0.1);\n  color: var(--accent-purple);\n  border: 1px solid rgba(157, 78, 221, 0.3);\n  box-shadow: 0 0 15px rgba(157, 78, 221, 0.15);\n}\n\n/* Subtitle Highlights */\n.subtitle-word {\n  display: inline-block;\n  font-family: var(--font-title);\n  font-weight: 900;\n  font-size: 42px; /* Scaled down for perfect visual hierarchy under 54px takeaways */\n  margin: 4px 8px;\n  transition: all 0.1s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  color: rgba(255, 255, 255, 0.3);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.subtitle-word.active {\n  color: #fff;\n  transform: scale(1.15);\n  text-shadow: 0 0 15px rgba(0, 242, 254, 0.5), 0 0 30px rgba(157, 78, 221, 0.3);\n  background: linear-gradient(135deg, #ffffff 20%, var(--accent-cyan) 60%, var(--accent-yellow) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
